<template>
    <div :class="wrapClasses">
        <div class="texteditor-wrapper" v-show="mounted">
            <label :for="id">{{ label }}</label>
            <textarea :name="name" :id="id" ref="textarea">
                {{ value }}
            </textarea>
        </div>
        <help-block v-if="error" :text="error"/>
        <block-loader v-if="!mounted"></block-loader>
    </div>
</template>

<script>
    export default {
        props: {
            label: String,
            name: String,
            id: String,
            withPara: {
                type: Boolean,
                default: true
            },
            error: {
                type: String,
                default: '',
                required: false
            },
            value: {
                required: true
            },
            withImage: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                mounted: false
            }
        },
        computed: {
            wrapClasses() {
                return "form-group" + (this.error? ' has-error' : '');
            },
        },
        methods: {
        },
        mounted() {
            $(document).ready(() => {
                let config = {
                    height: 300,
                    toolbar: [
                        ['style', ['bold', 'italic', 'underline', 'clear']],
                        ['font', ['strikethrough', 'superscript', 'subscript']],
                        ['fontsize', ['fontsize']],
                        ['color', ['color']],
                        this.withPara ? ['para', ['ul', 'ol', 'paragraph']]
                            : ['para'],
                        ['height', ['height']],
                        this.withImage ? ['insert', ['link', 'picture', 'hr']]
                            : ['insert', ['link']],
                    ]
                }

                config.callbacks = {
                    /*onInit: () => {
                        $(el).summernote("code", this.model);
                    },*/

                    onChange: content => {
                        this.$emit('input', content);
                    },

                    /*onBlur: obj => {
                        //$(el).summernote()
                        //this.$emit('input', content);
                    }*/
                };

                const el = this.$refs.textarea;
                $(el).summernote(config);

                this.mounted = true;
            });
        }
    }
</script>

<style lang="scss">

</style>
